import { createAction, props, union } from '@ngrx/store';

import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { StatsVersionCheckI } from 'src/app/api/stats-version-check/stats-version-check.result.int';
import { StatsVersionCheckQueryI } from 'src/app/api/stats-version-check/stats-version-check.query.int';

export const error = createAction('[Stats / Version Check] Error', props<{ error: SharedErrorObjectI }>());
export const load = createAction('[Stats / Version Check] Load', props<{
    query: StatsVersionCheckQueryI;
}>());
export const received = createAction('[Stats / Version Check] Received', props<{
    result: StatsVersionCheckI;
}>());
export const reset = createAction('[Stats / Version Check] Reset', props<Record<string, unknown>>());

const all = union({
    error,
    load,
    received,
    reset,
});
export type Actions = typeof all;
